import { Card, CardContent, CardFooter } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { SearchResult } from "../schema/schema";
import { ExternalLink, Search } from "lucide-react";

interface ResultsGridProps {
  results: SearchResult;
  onSearchImage: (url: string) => void;
}

export function ResultsGrid({ results, onSearchImage }: ResultsGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {results.results.map((result) => (
        <Card key={result.fileid} className="overflow-hidden">
          <div className="aspect-square relative group">
            <img
              src={result.url}
              alt={result.title}
              className="object-cover w-full h-full"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
              <Button
                variant="secondary"
                size="icon"
                onClick={() => onSearchImage(result.url)}
                className="h-8 w-8"
              >
                <Search className="h-4 w-4" />
              </Button>
            </div>
          </div>
          <CardContent className="p-4 space-y-2">
            <h3 className="font-semibold text-lg line-clamp-1">{result.title}</h3>
            <div className="flex flex-wrap gap-1">
              {result.tags.map((tag) => (
                <Badge key={tag} variant="secondary">
                  {tag}
                </Badge>
              ))}
            </div>
            <p className="text-sm text-muted-foreground">
              Similarity: {result.score.toFixed(2)}%
            </p>
          </CardContent>
          <CardFooter className="p-4 pt-0 flex flex-col gap-2">
            <a
              href={`steam://url/CommunityFilePage/${result.fileid}`}
              className="w-full block text-center bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600"
            >
              <ExternalLink className="h-4 w-4 mr-2 inline" />
              Open in Steam
            </a>
            <a
              href={`https://steamcommunity.com/sharedfiles/filedetails/?id=${result.fileid}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full block text-center border border-gray-300 text-gray-700 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 py-2 rounded-lg hover:bg-gray-100"
            >
              <ExternalLink className="h-4 w-4 mr-2 inline" />
              View on Steam Community
            </a>
          </CardFooter>
        </Card>
      ))}
    </div>
  );
}